function getSliderSettings() {
	return {
		slidesPerView: 1,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	};
}

function getSubSliderProductSettings() {
	return {
		slidesPerView: 3,
		direction: "vertical",
		navigation: false,
	};
}

function updatethumbnail() {
	let mediaElement = document.querySelector(".product__media-list");
	if (!mediaElement) return "";
	let mediaHeight = mediaElement.offsetHeight;
	let mediaThumbHeight = document.querySelector(".product__media-sublist");
	if (window.innerWidth > 1200) {
		mediaThumbHeight.style.height = mediaHeight + "px";
	}
}

const sliderInit = (isUpdate) => {
	if (window.customSwiperActive) {
		// Desativar eventos de sincronização se existirem
		const mainSwiper = document.querySelector(".js-media-list")?.swiper;
		const thumbSwiper = document.querySelector(".js-media-sublist")?.swiper;
		
		if (mainSwiper) {
			mainSwiper.off('slideChangeTransitionStart');
			mainSwiper.off('slideChange');
		}
		if (thumbSwiper) {
			thumbSwiper.off('transitionStart');
		}
		return;
	}

	if (
		(document.querySelectorAll(".product-section .js-media-list") &&
			document.querySelectorAll(".product-section .js-media-list").length >
				0) ||
		(document.querySelectorAll(".featured-product-section .js-media-list") &&
			document.querySelectorAll(".featured-product-section .js-media-list")
				.length > 0)
	) {
		let slider = new Swiper(".js-media-list", {
			slidesPerView: 1,
			spaceBetween: 4,
			navigation: {
				nextEl: ".swiper-btn--next",
				prevEl: ".swiper-btn--prev",
			},
			thumbs: {
				swiper: document.querySelector(".js-media-sublist").swiper,
			},
			on: {
				slideChangeTransitionStart: function () {
					document
						.querySelector(".js-media-sublist")
						.swiper.slideTo(
							document.querySelector(".js-media-list").swiper.activeIndex
						);
				},
				slideChange: function () {
					window.pauseAllMedia();
					this.params.noSwiping = false;
				},
				slideChangeTransitionEnd: function () {
					if (this.slides[this.activeIndex].querySelector("model-viewer")) {
						this.slides[this.activeIndex]
							.querySelector(".shopify-model-viewer-ui__button--poster")
							.removeAttribute("hidden");
					}
				},
				touchStart: function (s, e) {
					if (this.slides[this.activeIndex].querySelector("model-viewer")) {
						if (
							!this.slides[this.activeIndex]
								.querySelector("model-viewer")
								.classList.contains("shopify-model-viewer-ui__disabled")
						) {
							this.params.noSwiping = true;
							this.params.noSwipingClass = "swiper-slide";
						} else {
							this.params.noSwiping = false;
						}
					}
				},
			},
		});
		updatethumbnail();
		if (isUpdate) {
			setTimeout(function () {
				slider.update();
			}, 800);
		}
	}
};

window.addEventListener("resize", () => {
	updatethumbnail();
});

document.addEventListener("shopify:section:load", function () {
	updatethumbnail();
});

const subSliderInit = (isUpdate) => {
	if (window.customSwiperActive) return;

	if (
		(document.querySelectorAll(".product-section .js-media-sublist") &&
			document.querySelectorAll(".product-section .js-media-sublist").length >
				0) ||
		(document.querySelectorAll(".featured-product-section .js-media-sublist") &&
			document.querySelectorAll(".featured-product-section .js-media-sublist")
				.length > 0)
	) {
		let subSlider = new Swiper(".js-media-sublist", {
			centeredSlides: true,
			centeredSlidesBounds: true,
			slideToClickedSlide: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			slidesPerView: 4,
			spaceBetween: 4,
			autoHeight: true,
			direction: "horizontal",
			navigation: false,
			freeMode: true,
			preloadImages: false,
			lazy: true,
			transitionStart: function () {
				document
					.querySelector(".js-media-list")
					.swiper.slideTo(
						document.querySelector(".js-media-sublist").swiper.activeIndex
					);
			},
			breakpoints: {
				1200: {
					direction: "vertical",
					slidesPerView: "auto",
					allowTouchMove: true,
				},
			},
			on: {
				touchEnd: function (s, e) {
					let range = 5;
					let diff = (s.touches.diff = s.isHorizontal()
						? s.touches.currentX - s.touches.startX
						: s.touches.currentY - s.touches.startY);
					if (diff < range || diff > -range) s.allowClick = true;
				},
			},
			transitionStart: function () {
				document
					.querySelector(".js-media-list")
					.swiper.slideTo(
						document.querySelector(".js-media-sublist").swiper.activeIndex
					);
			},
		});

		if (subSlider.slides.length <= 3) {
			subSlider.params.centeredSlides = false;
			subSlider.update();
		}

		if (isUpdate) {
			setTimeout(function () {
				subSlider.update();
			}, 200);
		}
	}
};

function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	);
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute("role", "button");
	summary.setAttribute("aria-expanded", "false");

	if (summary.nextElementSibling.getAttribute("id")) {
		summary.setAttribute("aria-controls", summary.nextElementSibling.id);
	}

	summary.addEventListener("click", (event) => {
		event.currentTarget.setAttribute(
			"aria-expanded",
			!event.currentTarget.closest("details").hasAttribute("open")
		);
	});

	if (summary.closest("header-drawer")) return;
	summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== "ESCAPE") return;

	const openDetailsElement = event.target.closest("details[open]");
	if (!openDetailsElement) return;

	const summaryElement = openDetailsElement.querySelector("summary");
	openDetailsElement.removeAttribute("open");
	summaryElement.setAttribute("aria-expanded", false);
	summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (
			event.target !== container &&
			event.target !== last &&
			event.target !== first
		)
			return;

		document.addEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function () {
		document.removeEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if (
			(event.target === container || event.target === first) &&
			event.shiftKey
		) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener("focusout", trapFocusHandlers.focusout);
	document.addEventListener("focusin", trapFocusHandlers.focusin);

	elementToFocus.focus();
}

function pauseAllMedia() {
	document.querySelectorAll(".js-youtube").forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + "pauseVideo" + '","args":""}',
			"*"
		);
	});
	document.querySelectorAll(".js-vimeo").forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', "*");
	});
	document.querySelectorAll("video").forEach((video) => video.pause());
	document.querySelectorAll("product-model").forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause();
	});
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin);
	document.removeEventListener("focusout", trapFocusHandlers.focusout);
	document.removeEventListener("keydown", trapFocusHandlers.keydown);

	if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector("input");
		this.changeEvent = new Event("change", { bubbles: true });

		this.querySelectorAll("button").forEach((button) =>
			button.addEventListener("click", this.onButtonClick.bind(this))
		);

		var eventList = ["paste", "input"];

		for (event of eventList) {
			this.input.addEventListener(event, function (e) {
				const numberRegex = /^0*?[1-9]\d*$/;

				if (
					numberRegex.test(e.currentTarget.value) ||
					e.currentTarget.value === ""
				) {
					e.currentTarget.value;
				} else {
					e.currentTarget.value = 1;
				}
			});
		}

		this.input.addEventListener("focusout", function (e) {
			if (e.currentTarget.value === "") {
				e.currentTarget.value = 1;
			}
		});
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent);
	}
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

const serializeForm = (form) => {
	const obj = {};
	const formData = new FormData(form);
	for (const key of formData.keys()) {
		obj[key] = formData.get(key);
	}
	return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
	return {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: `application/${type}`,
		},
	};
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options["method"] || "post";
	var params = options["parameters"] || {};

	var form = document.createElement("form");
	form.setAttribute("method", method);
	form.setAttribute("action", path);

	for (var key in params) {
		var hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden");
		hiddenField.setAttribute("name", key);
		hiddenField.setAttribute("value", params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
	country_domid,
	province_domid,
	options
) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(
		options["hideElement"] || province_domid
	);

	Shopify.addListener(
		this.countryEl,
		"change",
		Shopify.bind(this.countryHandler, this)
	);

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute("data-default");
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute("data-provinces");
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = "none";
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement("option");
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = "";
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement("option");
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	},
};

class MenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.mainDetailsToggle = this.querySelector("details");
		const summaryElements = this.querySelectorAll("summary");
		this.addAccessibilityAttributes(summaryElements);

		if (navigator.platform === "iPhone")
			document.documentElement.style.setProperty(
				"--viewport-height",
				`${window.innerHeight}px`
			);

		this.addEventListener("keyup", this.onKeyUp.bind(this));
		this.addEventListener("focusout", this.onFocusOut.bind(this));
		this.bindEvents();
	}

	bindEvents() {
		this.querySelectorAll("summary").forEach((summary) =>
			summary.addEventListener("click", this.onSummaryClick.bind(this))
		);
		this.querySelectorAll("button").forEach((button) => {
			if (this.querySelector(".header__localization-button") === button) return;
			if (this.querySelector(".header__localization-lang-button") === button)
				return;
			button.addEventListener("click", this.onCloseButtonClick.bind(this));
		});
	}

	addAccessibilityAttributes(summaryElements) {
		summaryElements.forEach((element) => {
			element.setAttribute("role", "button");
			element.setAttribute("aria-expanded", false);
			element.setAttribute("aria-controls", element.nextElementSibling.id);
		});
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		const openDetailsElement = event.target.closest("details[open]");
		if (!openDetailsElement) return;

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
			: this.closeSubmenu(openDetailsElement);
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget;
		const detailsElement = summaryElement.parentNode;
		const isOpen = detailsElement.hasAttribute("open");

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault();
			isOpen
				? this.closeMenuDrawer(summaryElement)
				: this.openMenuDrawer(summaryElement);
		} else {
			trapFocus(
				summaryElement.nextElementSibling,
				detailsElement.querySelector("button")
			);

			setTimeout(() => {
				detailsElement.classList.add("menu-opening");
			});
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});
		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
			this.mainDetailsToggle.classList.remove("menu-opening");
			this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
				details.removeAttribute("open");
				details.classList.remove("menu-opening");
			});
			this.mainDetailsToggle
				.querySelector("summary")
				.setAttribute("aria-expanded", false);
			document.body.classList.remove(
				`overflow-hidden-${this.dataset.breakpoint}`
			);
			removeTrapFocus(elementToFocus);
			this.closeAnimation(this.mainDetailsToggle);
		}
	}

	onFocusOut(event) {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute("open") &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				this.closeMenuDrawer();
		});
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest("details");
		this.closeSubmenu(detailsElement);
	}

	closeSubmenu(detailsElement) {
		detailsElement.classList.remove("menu-opening");
		removeTrapFocus();
		this.closeAnimation(detailsElement);
	}

	closeAnimation(detailsElement) {
		let animationStart;

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time;
			}

			const elapsedTime = time - animationStart;

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation);
			} else {
				detailsElement.removeAttribute("open");
				if (detailsElement.closest("details[open]")) {
					trapFocus(
						detailsElement.closest("details[open]"),
						detailsElement.querySelector("summary")
					);
				}
			}
		};

		window.requestAnimationFrame(handleAnimation);
	}
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super();
	}

	openMenuDrawer(summaryElement) {
		this.header =
			this.header || document.getElementById("shopify-section-header");
		this.borderOffset =
			this.borderOffset ||
			this.closest(".header-wrapper").classList.contains(
				"header-wrapper--border-bottom"
			)
				? 1
				: 0;
		document.documentElement.style.setProperty(
			"--header-bottom-position",
			`${parseInt(
				this.header.getBoundingClientRect().bottom - this.borderOffset
			)}px`
		);

		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});

		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="ModalClose-"]').addEventListener(
			"click",
			this.hide.bind(this, false)
		);
		this.addEventListener("keyup", (event) => {
			if (event.code.toUpperCase() === "ESCAPE") this.hide();
		});
		if (this.classList.contains("media-modal")) {
			this.addEventListener("pointerup", (event) => {
				if (
					event.pointerType === "mouse" &&
					!event.target.closest("deferred-media, product-model")
				)
					this.hide();
			});
		} else {
			this.addEventListener("click", (event) => {
				if (event.target === this) this.hide();
			});
		}
	}

	connectedCallback() {
		if (this.moved) return;
		this.moved = true;
		document.body.appendChild(this);
	}

	show(opener) {
		this.openedBy = opener;
		const popup = this.querySelector(".template-popup");
		document.body.classList.add("overflow-hidden");
		this.setAttribute("open", "");
		if (popup) popup.loadContent();
		trapFocus(this, this.querySelector('[role="dialog"]'));
		window.pauseAllMedia();
	}

	hide() {
		let isOpen = false;

		this.removeAttribute("open");
		removeTrapFocus(this.openedBy);
		window.pauseAllMedia();

		document.querySelectorAll("body > quick-add-modal").forEach((el) => {
			if (el.hasAttribute("open")) {
				isOpen = true;
			}
		});

		if (!isOpen) {
			document.body.classList.remove("overflow-hidden");
			document.body.dispatchEvent(new CustomEvent("modalClosed"));
		}
	}
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector("button");

		if (!button) return;
		button.addEventListener("click", () => {
			const modal = document.querySelector(this.getAttribute("data-modal"));
			if (modal) modal.show(button);
		});
	}
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
			"click",
			this.loadContent.bind(this)
		);
		if (this.getAttribute("data-autoplay")) {
			this.loadContent();
		}
	}
	loadContent() {
		if (!this.getAttribute("loaded")) {
			const content = document.createElement("div");
			content.appendChild(
				this.querySelector("template").content.firstElementChild.cloneNode(true)
			);
			this.setAttribute("loaded", true);
			window.pauseAllMedia();
			const videoObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						if (this.getAttribute("data-autoplay")) {
							let playPromise = entry.target.play();
							if (playPromise !== undefined) {
								playPromise.then((_) => {}).catch((error) => {});
							}
						}
					} else {
						entry.target.pause();
					}
				});
			});
			const deferredElement = this.appendChild(
				content.querySelector("video, model-viewer, iframe")
			);

			if ( deferredElement.nodeName == "VIDEO" || deferredElement.nodeName == "IFRAME" ) {
				// force autoplay for safari

				if (this.classList.contains("video-section__media")) {
					let playPromise = deferredElement.play();
					if (playPromise !== undefined) {
						playPromise.then((_) => {}).catch((error) => {});
					}
					videoObserver.observe(deferredElement);
				} else {
					deferredElement.play();
				}
			}
			if (
				this.closest(".swiper")?.swiper.slides[
					this.closest(".swiper").swiper.activeIndex
				].querySelector("model-viewer")
			) {
				if (
					!this.closest(".swiper")
						.swiper.slides[
							this.closest(".swiper").swiper.activeIndex
						].querySelector("model-viewer")
						.classList.contains("shopify-model-viewer-ui__disabled")
				) {
					this.closest(".swiper").swiper.params.noSwiping = true;
					this.closest(".swiper").swiper.params.noSwipingClass = "swiper-slide";
				}
			}
		}
	}
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
	constructor() {
		super();
		this.slider = this.querySelector(".slider");
		this.sliderItems = this.querySelectorAll(".slider__slide");
		this.pageCount = this.querySelector(".slider-counter--current");
		this.pageTotal = this.querySelector(".slider-counter--total");
		this.prevButton = this.querySelector('button[name="previous"]');
		this.nextButton = this.querySelector('button[name="next"]');

		if (!this.slider || !this.nextButton) return;

		const resizeObserver = new ResizeObserver((entries) => this.initPages());
		resizeObserver.observe(this.slider);

		this.slider.addEventListener("scroll", this.update.bind(this));
		this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
		this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
	}

	initPages() {
		if (!this.sliderItems.length === 0) return;
		this.slidesPerPage = Math.floor(
			this.slider.clientWidth / this.sliderItems[0].clientWidth
		);
		this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
		this.update();
	}

	update() {
		if (!this.pageCount || !this.pageTotal) return;
		this.currentPage =
			Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

		if (this.currentPage === 1) {
			this.prevButton.setAttribute("disabled", true);
		} else {
			this.prevButton.removeAttribute("disabled");
		}

		if (this.currentPage === this.totalPages) {
			this.nextButton.setAttribute("disabled", true);
		} else {
			this.nextButton.removeAttribute("disabled");
		}

		this.pageCount.textContent = this.currentPage;
		this.pageTotal.textContent = this.totalPages;
	}

	onButtonClick(event) {
		event.preventDefault();
		const slideScrollPosition =
			event.currentTarget.name === "next"
				? this.slider.scrollLeft + this.sliderItems[0].clientWidth
				: this.slider.scrollLeft - this.sliderItems[0].clientWidth;
		this.slider.scrollTo({
			left: slideScrollPosition,
		});
	}
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("change", this.onVariantChange);
	}

	onVariantChange() {
		// Inicializar lastSelectedColor ANTES de qualquer detecção
		this.initializeColorTracking();
		
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, "", false);
		this.updatePickupAvailability();
		this.updateVariantStatuses();

		if (!this.currentVariant) {
			this.toggleAddButton(true, "", true);
			this.setUnavailable();
		} else {
			this.updateMedia();
			this.updateMediaSub();
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
		}
	}

	// Método para inicializar o rastreamento de cor
	initializeColorTracking() {
		debugLog('🎯 initializeColorTracking INICIADO');
		
		// Se ainda não inicializamos o tracking, fazer agora
		if (!this.lastSelectedColor) {
			const selectedColorInput = document.querySelector('input[type="radio"][name*="CORES"]:checked, input[type="radio"][name*="COR"]:checked, input[type="radio"][name*="COLOR"]:checked');
			
			if (selectedColorInput) {
				this.lastSelectedColor = selectedColorInput.value.toLowerCase().trim();
				debugLog('🎯 Inicializando tracking de cor:', this.lastSelectedColor);
			}
		}
	}

	updateOptions() {
		//this.options = Array.from(
		//	this.querySelectorAll("select"),
		//	(select) => select.value
		//);
		const fieldsets = Array.from(this.querySelectorAll(".js-radio-colors"));

		this.options = Array.from(
			this.querySelectorAll("select"),
			(select) => select.value
		).concat(
			fieldsets.map((fieldset) => {
				return Array.from(fieldset.querySelectorAll("input")).find(
					(radio) => radio.checked
				).value;
			})
		);
	}

	updateMasterId() {
		if (this.variantData || this.querySelector('[type="application/json"]')) {
			this.currentVariant = this.getVariantData().find((variant) => {
				this.options.sort();
				variant.options.sort();

				return !variant.options
					.map((option, index) => {
						return this.options[index] === option;
					})
					.includes(false);
			});
		}
	}

	updateMedia() {
		debugLog('📱 updateMedia INICIADO');
		
		if (!this.currentVariant || !this.currentVariant?.featured_media) {
			debugLog('❌ Nenhuma variante ou mídia featured encontrada');
			return;
		}

		// Detectar se a mudança é apenas de tamanho (não de cor)
		const isOnlySizeChange = this.detectOnlySizeChange();
		debugLog('🔍 Tipo de mudança detectada:', { isOnlySizeChange });

		if (isOnlySizeChange) {
			debugLog('📐 Apenas mudança de tamanho detectada - mantendo filtro de cor ativo sem reordenar mídia');
			// Para mudanças apenas de tamanho, não movemos mídia nem recriamos swipers
			// Apenas reaplicar o filtro de cor existente mantendo posição atual
			setTimeout(() => {
				// Salvar posição atual do swiper antes de reaplicar filtro
				const currentMainIndex = document.querySelector('.js-media-list')?.swiper?.activeIndex || 0;
				debugLog('💾 Salvando posição atual do swiper:', currentMainIndex);
				
				this.applyColorFilterWithPosition(currentMainIndex);
			}, 50);
			return;
		}

		debugLog('🖼️ Mudança de cor detectada - processando reordenação de mídia');

		const newMedia = document.querySelector(
			`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
		);

		if (!newMedia) {
			debugLog('❌ Nova mídia não encontrada');
			return;
		}

		const parent = newMedia.parentElement;
		parent.prepend(newMedia);

		window.setTimeout(() => {
			parent.scroll(0, 0);
		});

		if (document.querySelector(".js-media-list")) {
			sliderInit();
		}
	}

	updateMediaSub() {
		debugLog('🖼️ updateMediaSub INICIADO');
		
		if (!this.currentVariant || !this.currentVariant?.featured_media) {
			debugLog('❌ Nenhuma variante ou mídia featured encontrada (sub)');
			return;
		}

		// Detectar se a mudança é apenas de tamanho (não de cor)
		const isOnlySizeChange = this.detectOnlySizeChange();
		debugLog('🔍 Tipo de mudança detectada (sub):', { isOnlySizeChange });

		if (isOnlySizeChange) {
			debugLog('📐 Apenas mudança de tamanho detectada (sub) - mantendo filtro de cor ativo');
			// Para mudanças apenas de tamanho, não fazemos nada aqui
			return;
		}

		debugLog('🖼️ Mudança de cor detectada (sub) - processando reordenação de mídia');

		const newMediaSub = document.querySelector(
			`[data-media-sub-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
		);

		if (
			document.querySelector(".js-media-sublist") &&
			document.querySelector(".js-media-sublist").swiper != null
		) {
			document.querySelector(".js-media-sublist").swiper.destroy();
		}

		if (!newMediaSub) {
			debugLog('❌ Nova mídia sub não encontrada');
			return;
		}

		const parentSub = newMediaSub.parentElement;
		parentSub.prepend(newMediaSub);

		window.setTimeout(() => {
			parentSub.scroll(0, 0);
		});

		if (document.querySelector(".js-media-sublist")) {
			subSliderInit();
		}
	}

	// Método para detectar se a mudança é apenas de tamanho
	detectOnlySizeChange() {
		debugLog('🔍 detectOnlySizeChange INICIADO');
		
		// Verificar se existe uma cor selecionada
		const selectedColorInput = document.querySelector('input[type="radio"][name*="CORES"]:checked, input[type="radio"][name*="COR"]:checked, input[type="radio"][name*="COLOR"]:checked');
		
		if (!selectedColorInput) {
			debugLog('❌ Nenhuma cor selecionada - não é mudança apenas de tamanho');
			return false;
		}

		const currentColor = selectedColorInput.value.toLowerCase().trim();
		
		// Se não temos lastSelectedColor ainda, something is wrong
		if (!this.lastSelectedColor) {
			debugLog('⚠️ lastSelectedColor não inicializado - tratando como mudança de cor');
			this.lastSelectedColor = currentColor;
			return false;
		}

		// Se é a primeira mudança de variante, sempre tratar como mudança de cor
		if (this.isFirstVariantChange) {
			debugLog('🆕 Primeira mudança de variante - tratando como mudança de cor');
			this.isFirstVariantChange = false;
			return false;
		}

		const lastColor = this.lastSelectedColor;
		
		debugLog('🎨 Comparando cores:', { currentColor, lastColor });
		
		// Se a cor não mudou, então é apenas mudança de tamanho
		const isOnlySizeChange = currentColor === lastColor;
		
		// Atualizar a cor armazenada apenas se mudou
		if (!isOnlySizeChange) {
			this.lastSelectedColor = currentColor;
			debugLog('🔄 Cor mudou - atualizando lastSelectedColor para:', this.lastSelectedColor);
		}
		
		debugLog('📊 Resultado da detecção:', { 
			currentColor, 
			lastColor, 
			isOnlySizeChange,
			currentLastColor: this.lastSelectedColor 
		});
		
		return isOnlySizeChange;
	}

	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === "false") return;
		window.history.replaceState(
			{},
			"",
			`${this.dataset.url}?variant=${this.currentVariant.id}`
		);
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
		);
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event("change", { bubbles: true }));
		});
	}

	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter(
			(variant) => this.querySelector(":checked").value === variant.option1
		);
		const inputWrappers = [...this.querySelectorAll(".product-form__input")];
		inputWrappers.forEach((option, index) => {
			if (index === 0) return;
			const optionInputs = [
				...option.querySelectorAll('input[type="radio"], option'),
			];
			const previousOptionSelected =
				inputWrappers[index - 1].querySelector(":checked").value;
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter(
					(variant) =>
						variant.available &&
						variant[`option${index}`] === previousOptionSelected
				)
				.map((variantOption) => variantOption[`option${index + 1}`]);
			this.setInputAvailability(optionInputs, availableOptionInputsValue);
		});
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
				if (input.tagName === "OPTION") {
					input.innerText = input.getAttribute("value");
				} else if (input.tagName === "INPUT") {
					input.classList.remove("disabled");
				}
			} else {
				if (input.tagName === "OPTION") {
					input.innerText =
						window.variantStrings.unavailable_with_option.replace(
							"[value]",
							input.getAttribute("value")
						);
				} else if (input.tagName === "INPUT") {
					input.classList.add("disabled");
				}
			}
		});
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector("pickup-availability");
		if (!pickUpAvailability) return;

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id);
		} else {
			pickUpAvailability.removeAttribute("available");
			pickUpAvailability.innerHTML = "";
		}
	}

	renderProductInfo() {
		const requestedVariantId = this.currentVariant.id;
		const sectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section;

		fetch(
			`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
				this.dataset.originalSection
					? this.dataset.originalSection
					: this.dataset.section
			}`
		)
			.then((response) => response.text())
			.then((responseText) => {
				if (this.currentVariant.id !== requestedVariantId) return;

				const html = new DOMParser().parseFromString(responseText, "text/html");
				const destination = document.getElementById(
					`price-${this.dataset.section}`
				);
				const source = html.getElementById(
					`price-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				);
				const skuSource = html.getElementById(
					`Sku-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				);
				const skuDestination = document.getElementById(
					`Sku-${this.dataset.section}`
				);
				const inventorySource = html.getElementById(
					`Inventory-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				);
				const inventoryDestination = document.getElementById(
					`Inventory-${this.dataset.section}`
				);

				if (source && destination) destination.innerHTML = source.innerHTML;
				if (inventorySource && inventoryDestination)
					inventoryDestination.innerHTML = inventorySource.innerHTML;
				if (skuSource && skuDestination) {
					skuDestination.innerHTML = skuSource.innerHTML;
					skuDestination.classList.toggle(
						"visibility-hidden",
						skuSource.classList.contains("visibility-hidden")
					);
				}

				const price = document.getElementById(`price-${this.dataset.section}`);

				if (price) price.classList.remove("visibility-hidden");

				if (inventoryDestination)
					inventoryDestination.classList.toggle(
						"visibility-hidden",
						inventorySource.innerText === ""
					);

				const addButtonUpdated = html.getElementById(
					`ProductSubmitButton-${sectionId}`
				);
				this.toggleAddButton(
					addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
					//!this.currentVariant.available,
					window.variantStrings.soldOut
				);
			});
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(
			`product-form-${this.dataset.section}`
		);

		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelectorAll(
			'[name="add"] > .add_to_cart_quantity'
		);
		if (!addButton) return;

		if (disable) {
			addButton.setAttribute("disabled", "disabled");

			if (text) {
				addButtonText.forEach((elem) => {
					elem.innerHTML = `${text}`;
				});
			}
		} else {
			addButton.removeAttribute("disabled");
			addButtonText.forEach((elem) => {
				elem.innerHTML = `${window.variantStrings.addToCart}`;
			});
		}

		if (!modifyClass) return;
	}

	setUnavailable() {
		const button = document.getElementById(
			`product-form-${this.dataset.section}`
		);
		const addButton = button.querySelector('[name="add"]');
		const addButtonText = button.querySelectorAll(
			'[name="add"] > .add_to_cart_quantity'
		);
		const price = document.getElementById(`price-${this.dataset.section}`);
		const inventory = document.getElementById(
			`Inventory-${this.dataset.section}`
		);
		const sku = document.getElementById(`Sku-${this.dataset.section}`);
		//const price = document.getElementById(`price-${this.dataset.section}`);
		if (!addButton) return;
		//addButtonText.textContent = window.variantStrings.unavailable;
		//if (price) price.classList.add('visibility-hidden');
		addButtonText.forEach((elem) => {
			elem.innerHTML = `${window.variantStrings.unavailable}`;
		});
		if (price) price.classList.add("visibility-hidden");
		if (inventory) inventory.classList.add("visibility-hidden");
		if (sku) sku.classList.add("visibility-hidden");
	}

	getVariantData() {
		//if (this.variantData || this.querySelector('[type="application/json"]')) {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
		//}
	}

	// Método para mostrar todas as imagens (quando não há filtro de cor)
	showAllImages() {
		debugLog('🌐 showAllImages INICIADO');
		
		const mainContainer = document.querySelector('.product__media-list');
		const thumbContainer = document.querySelector('.product__media-sublist');
		
		if (!mainContainer || !thumbContainer) {
			debugLog('❌ Containers não encontrados para showAllImages');
			return;
		}

		const mainSlides = [...mainContainer.querySelectorAll('.product__media-item')];
		const thumbSlides = [...thumbContainer.querySelectorAll('.product__media-subitem')];
		
		debugLog('🔓 Mostrando todos os slides:', { mainSlides: mainSlides.length, thumbSlides: thumbSlides.length });
		
		// Mostrar todos os slides - remover TODAS as ocultações
		mainSlides.forEach((slide, index) => {
			slide.classList.remove('color-filtered-hidden');
			slide.style.display = '';
			slide.style.visibility = '';
			slide.style.opacity = '';
			slide.style.position = '';
			slide.style.left = '';
			slide.removeAttribute('data-filtered');
			
			debugLog(`🔓 Slide ${index} LIBERADO`);
		});
		
		thumbSlides.forEach((thumb, index) => {
			thumb.classList.remove('color-filtered-hidden');
			thumb.style.display = '';
			thumb.style.visibility = '';
			thumb.style.opacity = '';
			thumb.style.position = '';
			thumb.style.left = '';
			thumb.removeAttribute('data-filtered');
			
			debugLog(`🔓 Thumb ${index} LIBERADO`);
		});

		// Recriar swipers com sincronização adequada (mesma estratégia)
		setTimeout(() => {
			try {
				const mainSwiper = document.querySelector('.js-media-list')?.swiper;
				const thumbSwiper = document.querySelector('.js-media-sublist')?.swiper;
				
				debugLog('🎛️ Recriando swipers (showAllImages):', { mainSwiper: !!mainSwiper, thumbSwiper: !!thumbSwiper });
				
				// Marcar que estamos recriando swipers
				window.RECREATING_SWIPERS = true;
				
				// Destruir swipers existentes
				if (mainSwiper) {
					mainSwiper.destroy(true, true);
					debugLog('🔄 Main swiper destruído (showAllImages)');
				}
				if (thumbSwiper) {
					thumbSwiper.destroy(true, true);
					debugLog('🔄 Thumb swiper destruído (showAllImages)');
				}
				
				// ESTRATÉGIA SEQUENCIAL: Criar thumb primeiro, depois main
				setTimeout(() => {
					// 1. Criar thumb swiper primeiro
					debugLog('🔨 Criando thumb swiper (showAllImages)...');
					subSliderInit(true);
					
					setTimeout(() => {
						// 2. Criar main swiper com referência ao thumb
						debugLog('🔨 Criando main swiper (showAllImages)...');
						sliderInit(true);
						
						setTimeout(() => {
							// 3. Garantir sincronização manual
							debugLog('🔗 Estabelecendo sincronização manual (showAllImages)...');
							this.establishSwiperSync();
							
							// 4. Resetar flag
							setTimeout(() => {
								window.RECREATING_SWIPERS = false;
								debugLog('🏁 Flag RECREATING_SWIPERS resetada (showAllImages)');
							}, 100);
						}, 150);
					}, 100);
				}, 50);
				
			} catch (error) {
				debugLog('❌ Erro ao recriar swipers (showAllImages):', error);
				window.RECREATING_SWIPERS = false;
			}
		}, 100);
	}

	// Método para validar se o filtro foi aplicado corretamente
	validateFilter(expectedColor) {
		debugLog('🔍 validateFilter INICIADO para cor:', expectedColor);
		
		const mainContainer = document.querySelector('.product__media-list');
		if (!mainContainer) return;

		const visibleSlides = [...mainContainer.querySelectorAll('.product__media-item:not([data-filtered="true"])')];
		const hiddenSlides = [...mainContainer.querySelectorAll('.product__media-item[data-filtered="true"]')];
		
		debugLog('📊 Resultado da validação:', { 
			visibleSlides: visibleSlides.length, 
			hiddenSlides: hiddenSlides.length,
			expectedColor 
		});
		
		// Se tudo está escondido, isso pode ser um problema
		if (visibleSlides.length === 0) {
			debugLog('🚨 PROBLEMA: Nenhum slide visível! Tentando mostrar todos...');
			setTimeout(() => {
				this.showAllImages();
			}, 100);
		}
		
		debugLog('✅ Validação concluída');
	}

	// Método para aplicar filtro de cor mantendo posição específica
	applyColorFilterWithPosition(targetIndex = 0) {
		debugLog('🎯 applyColorFilterWithPosition INICIADO com índice:', targetIndex);
		
		// Verificar se há uma opção de cor selecionada
		const selectedColorInput = document.querySelector('input[type="radio"][name*="CORES"]:checked, input[type="radio"][name*="COR"]:checked, input[type="radio"][name*="COLOR"]:checked');
		
		if (!selectedColorInput) {
			debugLog('❌ Nenhuma cor selecionada');
			return;
		}

		const selectedColor = selectedColorInput.value.toLowerCase().trim();
		debugLog('🎨 Aplicando filtro para cor mantendo posição:', { selectedColor, targetIndex });
		
		// Aplicar filtro com posição específica
		setTimeout(() => {
			this.filterImagesByColorWithPosition(selectedColor, targetIndex);
		}, 50);
	}

	// Método para filtrar imagens baseado na cor - VERSÃO AGRESSIVA
	filterImagesByColor(color) {
		debugLog('🎯 filterImagesByColor INICIADO para cor:', color);
		
		const mainContainer = document.querySelector('.product__media-list');
		const thumbContainer = document.querySelector('.product__media-sublist');
		
		if (!mainContainer || !thumbContainer) {
			debugLog('❌ Containers não encontrados', { mainContainer: !!mainContainer, thumbContainer: !!thumbContainer });
			return;
		}

		const mainSlides = [...mainContainer.querySelectorAll('.product__media-item')];
		const thumbSlides = [...thumbContainer.querySelectorAll('.product__media-subitem')];
		
		debugLog('📊 Elementos encontrados:', { mainSlides: mainSlides.length, thumbSlides: thumbSlides.length });
		
		let hasVisibleSlides = false;
		let slidesToShow = [];

		// Primeiro, mapear quais slides devem ser visíveis
		mainSlides.forEach((slide, index) => {
			const slideImg = slide.querySelector('img');
			const slideAlt = slideImg?.alt || '';
			
			// Extrair cor da imagem com múltiplas estratégias
			let slideColor = '';
			
			// Estratégia 1: Procurar "color:" no alt
			const colorMatch = slideAlt.match(/color:([^,\s]+)/i);
			if (colorMatch && colorMatch[1]) {
				slideColor = colorMatch[1].trim().toLowerCase();
			}
			// Estratégia 2: Primeira palavra antes da vírgula
			else if (slideAlt.includes(',')) {
				slideColor = slideAlt.split(',')[0].trim().toLowerCase();
			}
			// Estratégia 3: Todo o alt text
			else {
				slideColor = slideAlt.trim().toLowerCase();
			}

			// Normalizar cores para comparação (remover acentos, espaços, etc)
			const normalizedSlideColor = slideColor.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, '');
			const normalizedSelectedColor = color.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, '');

			// Comparação mais flexível
			const matches = normalizedSlideColor === normalizedSelectedColor || 
			               normalizedSlideColor.includes(normalizedSelectedColor) || 
			               normalizedSelectedColor.includes(normalizedSlideColor);
			
			debugLog(`🖼️ Slide ${index}:`, { alt: slideAlt, slideColor, selectedColor: color, matches });
			
			if (matches) {
				slidesToShow.push({
					slide: slide,
					index: index
				});
				hasVisibleSlides = true;
			}
		});

		debugLog('📈 Resultado da análise:', { totalSlidesToShow: slidesToShow.length, hasVisibleSlides });

		// Se nenhum slide corresponder à cor, mostrar todos
		if (!hasVisibleSlides) {
			debugLog('⚠️ Nenhum slide encontrado, mostrando todos');
			this.showAllImages();
			return;
		}

		debugLog('🔧 Aplicando OCULTAÇÃO AGRESSIVA para todos os slides...');

		// ESTRATÉGIA AGRESSIVA: Esconder todos os slides com múltiplas técnicas
		mainSlides.forEach((slide, index) => {
			// Múltiplas camadas de ocultação
			slide.classList.add('color-filtered-hidden');
			slide.style.display = 'none';
			slide.style.visibility = 'hidden';
			slide.style.opacity = '0';
			slide.style.position = 'absolute';
			slide.style.left = '-9999px';
			slide.setAttribute('data-filtered', 'true');
			
			debugLog(`🚫 Slide ${index} OCULTO COMPLETAMENTE`);
		});
		
		thumbSlides.forEach((thumb, index) => {
			// Múltiplas camadas de ocultação
			thumb.classList.add('color-filtered-hidden');
			thumb.style.display = 'none';
			thumb.style.visibility = 'hidden';
			thumb.style.opacity = '0';
			thumb.style.position = 'absolute';
			thumb.style.left = '-9999px';
			thumb.setAttribute('data-filtered', 'true');
			
			debugLog(`🚫 Thumb ${index} OCULTO COMPLETAMENTE`);
		});

		debugLog('✅ Mostrando slides filtrados...');

		// Mostrar apenas os slides que correspondem à cor
		slidesToShow.forEach(({slide, index}) => {
			// Remover todas as ocultações
			slide.classList.remove('color-filtered-hidden');
			slide.style.display = '';
			slide.style.visibility = '';
			slide.style.opacity = '';
			slide.style.position = '';
			slide.style.left = '';
			slide.removeAttribute('data-filtered');
			
			debugLog(`✅ Slide ${index} MOSTRADO`);
			
			// Encontrar e mostrar miniatura correspondente
			const mediaId = slide.getAttribute('data-media-id')?.split(' ')[0]?.trim();
			const correspondingThumb = thumbSlides.find(thumb => 
				thumb.getAttribute('data-media-sub-id')?.split(' ')[0]?.trim() === mediaId
			);
			
			if (correspondingThumb) {
				// Remover todas as ocultações
				correspondingThumb.classList.remove('color-filtered-hidden');
				correspondingThumb.style.display = '';
				correspondingThumb.style.visibility = '';
				correspondingThumb.style.opacity = '';
				correspondingThumb.style.position = '';
				correspondingThumb.style.left = '';
				correspondingThumb.removeAttribute('data-filtered');
				
				debugLog(`✅ Thumb correspondente ao slide ${index} MOSTRADO`);
			}
		});

		debugLog('🔄 Recreando swipers com sincronização adequada...');

		// NOVA ESTRATÉGIA: Recriação sequencial com sincronização garantida
		setTimeout(() => {
			try {
				const mainSwiper = document.querySelector('.js-media-list')?.swiper;
				const thumbSwiper = document.querySelector('.js-media-sublist')?.swiper;
				
				debugLog('🎛️ Swipers encontrados:', { mainSwiper: !!mainSwiper, thumbSwiper: !!thumbSwiper });
				
				// Marcar que estamos recriando swipers
				window.RECREATING_SWIPERS = true;
				
				// Destruir swipers existentes
				if (mainSwiper) {
					mainSwiper.destroy(true, true);
					debugLog('🔄 Main swiper destruído');
				}
				if (thumbSwiper) {
					thumbSwiper.destroy(true, true);
					debugLog('🔄 Thumb swiper destruído');
				}
				
				// ESTRATÉGIA SEQUENCIAL: Criar thumb primeiro, depois main
				setTimeout(() => {
					// 1. Criar thumb swiper primeiro
					debugLog('🔨 Criando thumb swiper...');
					subSliderInit(true);
					
					setTimeout(() => {
						// 2. Criar main swiper com referência ao thumb
						debugLog('🔨 Criando main swiper...');
						sliderInit(true);
						
						setTimeout(() => {
							// 3. Garantir sincronização manual
							debugLog('🔗 Estabelecendo sincronização manual...');
							this.establishSwiperSync();
							
							// 4. Resetar flag
							setTimeout(() => {
								window.RECREATING_SWIPERS = false;
								debugLog('🏁 Flag RECREATING_SWIPERS resetada');
								
								// 5. Validar filtro
								this.validateFilter(color);
							}, 100);
						}, 150);
					}, 100);
				}, 50);
				
			} catch (error) {
				debugLog('❌ Erro ao recriar swipers:', error);
				window.RECREATING_SWIPERS = false;
			}
		}, 100);
	}

	// Método para aplicar filtro de cor baseado na variante selecionada
	applyColorFilter() {
		debugLog('🚀 applyColorFilter INICIADO');
		
		// Verificar se há uma opção de cor selecionada
		const selectedColorInput = document.querySelector('input[type="radio"][name*="CORES"]:checked, input[type="radio"][name*="COR"]:checked, input[type="radio"][name*="COLOR"]:checked');
		
		debugLog('🔍 Cor selecionada encontrada:', selectedColorInput?.value || 'NENHUMA');
		
		if (!selectedColorInput) {
			debugLog('❌ Nenhuma cor selecionada, mostrando todas as imagens');
			// Se não há cor selecionada, mostrar todas as imagens
			this.showAllImages();
			return;
		}

		const selectedColor = selectedColorInput.value.toLowerCase().trim();
		debugLog('🎨 Aplicando filtro para cor:', selectedColor);
		
		// Aplicar filtro após um pequeno delay para garantir que o DOM foi atualizado
		setTimeout(() => {
			debugLog('⏱️ Executando filterImagesByColor com delay de 50ms');
			this.filterImagesByColor(selectedColor);
		}, 50);
	}

	// Método para filtrar imagens baseado na cor mantendo posição específica
	filterImagesByColorWithPosition(color, targetIndex = 0) {
		debugLog('🎯 filterImagesByColorWithPosition INICIADO para cor:', color, 'posição:', targetIndex);
		
		const mainContainer = document.querySelector('.product__media-list');
		const thumbContainer = document.querySelector('.product__media-sublist');
		
		if (!mainContainer || !thumbContainer) {
			debugLog('❌ Containers não encontrados', { mainContainer: !!mainContainer, thumbContainer: !!thumbContainer });
			return;
		}

		const mainSlides = [...mainContainer.querySelectorAll('.product__media-item')];
		const thumbSlides = [...thumbContainer.querySelectorAll('.product__media-subitem')];
		
		debugLog('📊 Elementos encontrados:', { mainSlides: mainSlides.length, thumbSlides: thumbSlides.length });
		
		let hasVisibleSlides = false;
		let slidesToShow = [];

		// Mapear quais slides devem ser visíveis
		mainSlides.forEach((slide, index) => {
			const slideImg = slide.querySelector('img');
			const slideAlt = slideImg?.alt || '';
			
			// Extrair cor da imagem
			let slideColor = '';
			const colorMatch = slideAlt.match(/color:([^,\s]+)/i);
			if (colorMatch && colorMatch[1]) {
				slideColor = colorMatch[1].trim().toLowerCase();
			} else if (slideAlt.includes(',')) {
				slideColor = slideAlt.split(',')[0].trim().toLowerCase();
			} else {
				slideColor = slideAlt.trim().toLowerCase();
			}

			// Comparação
			const normalizedSlideColor = slideColor.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, '');
			const normalizedSelectedColor = color.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, '');
			const matches = normalizedSlideColor === normalizedSelectedColor || 
			               normalizedSlideColor.includes(normalizedSelectedColor) || 
			               normalizedSelectedColor.includes(normalizedSlideColor);
			
			debugLog(`🖼️ Slide ${index}:`, { alt: slideAlt, slideColor, selectedColor: color, matches });
			
			if (matches) {
				slidesToShow.push({ slide: slide, index: index });
				hasVisibleSlides = true;
			}
		});

		if (!hasVisibleSlides) {
			debugLog('⚠️ Nenhum slide encontrado, mostrando todos');
			this.showAllImages();
			return;
		}

		debugLog('🔧 Aplicando filtro mantendo posição...');

		// Esconder todos os slides
		mainSlides.forEach((slide, index) => {
			slide.classList.add('color-filtered-hidden');
			slide.style.display = 'none';
			slide.style.visibility = 'hidden';
			slide.style.opacity = '0';
			slide.style.position = 'absolute';
			slide.style.left = '-9999px';
			slide.setAttribute('data-filtered', 'true');
		});
		
		thumbSlides.forEach((thumb, index) => {
			thumb.classList.add('color-filtered-hidden');
			thumb.style.display = 'none';
			thumb.style.visibility = 'hidden';
			thumb.style.opacity = '0';
			thumb.style.position = 'absolute';
			thumb.style.left = '-9999px';
			thumb.setAttribute('data-filtered', 'true');
		});

		// Mostrar slides filtrados
		slidesToShow.forEach(({slide, index}) => {
			slide.classList.remove('color-filtered-hidden');
			slide.style.display = '';
			slide.style.visibility = '';
			slide.style.opacity = '';
			slide.style.position = '';
			slide.style.left = '';
			slide.removeAttribute('data-filtered');
			
			const mediaId = slide.getAttribute('data-media-id')?.split(' ')[0]?.trim();
			const correspondingThumb = thumbSlides.find(thumb => 
				thumb.getAttribute('data-media-sub-id')?.split(' ')[0]?.trim() === mediaId
			);
			
			if (correspondingThumb) {
				correspondingThumb.classList.remove('color-filtered-hidden');
				correspondingThumb.style.display = '';
				correspondingThumb.style.visibility = '';
				correspondingThumb.style.opacity = '';
				correspondingThumb.style.position = '';
				correspondingThumb.style.left = '';
				correspondingThumb.removeAttribute('data-filtered');
			}
		});

		// Atualizar swipers SEM recriar, apenas atualizando
		setTimeout(() => {
			try {
				const mainSwiper = document.querySelector('.js-media-list')?.swiper;
				const thumbSwiper = document.querySelector('.js-media-sublist')?.swiper;
				
				if (mainSwiper && thumbSwiper) {
					debugLog('🔄 Atualizando swipers existentes mantendo posição:', targetIndex);
					
					// Atualizar sem recriar
					mainSwiper.update();
					thumbSwiper.update();
					
					// Ir para a posição desejada (limitada pelo número de slides visíveis)
					const maxIndex = Math.max(0, slidesToShow.length - 1);
					const safeIndex = Math.min(targetIndex, maxIndex);
					
					debugLog('🎯 Navegando para posição segura:', { targetIndex, maxIndex, safeIndex });
					
					setTimeout(() => {
						mainSwiper.slideTo(safeIndex, 0); // sem animação
						thumbSwiper.slideTo(safeIndex, 0); // sem animação
						
						// Atualizar estados visuais ativos
						const visibleMainSlides = [...document.querySelectorAll('.js-media-list .swiper-slide:not([data-filtered="true"])')];
						const visibleThumbSlides = [...document.querySelectorAll('.js-media-sublist .swiper-slide:not([data-filtered="true"])')];
						
						// Remover todas as classes ativas
						visibleMainSlides.forEach(slide => {
							slide.classList.remove('swiper-slide-active', 'swiper-slide-next', 'swiper-slide-prev');
						});
						visibleThumbSlides.forEach(slide => {
							slide.classList.remove('swiper-slide-active', 'swiper-slide-thumb-active');
						});
						
						// Aplicar classe ativa no slide correto
						if (visibleMainSlides[safeIndex]) {
							visibleMainSlides[safeIndex].classList.add('swiper-slide-active');
							debugLog('✅ Estado ativo aplicado no main slide:', safeIndex);
						}
						
						if (visibleThumbSlides[safeIndex]) {
							visibleThumbSlides[safeIndex].classList.add('swiper-slide-active', 'swiper-slide-thumb-active');
							debugLog('✅ Estado ativo aplicado no thumb slide:', safeIndex);
						}
						
						debugLog('✅ Posição e estados visuais atualizados com sucesso');
					}, 50);
				}
			} catch (error) {
				debugLog('❌ Erro ao atualizar swipers:', error);
			}
		}, 100);
	}

	// Método para estabelecer sincronização entre swipers
	establishSwiperSync() {
		debugLog('🔗 establishSwiperSync INICIADO');
		
		try {
			const mainSwiper = document.querySelector('.js-media-list')?.swiper;
			const thumbSwiper = document.querySelector('.js-media-sublist')?.swiper;
			
			if (!mainSwiper || !thumbSwiper) {
				debugLog('❌ Swipers não encontrados para sincronização', { mainSwiper: !!mainSwiper, thumbSwiper: !!thumbSwiper });
				return;
			}
			
			debugLog('✅ Swipers encontrados, estabelecendo sincronização...');
			
			// Criar mapeamento de índices para slides visíveis
			const visibleMainSlides = [...document.querySelectorAll('.js-media-list .swiper-slide:not([data-filtered="true"])')];
			const visibleThumbSlides = [...document.querySelectorAll('.js-media-sublist .swiper-slide:not([data-filtered="true"])')];
			
			debugLog('🗺️ Mapeamento de índices criado:', { 
				mainVisible: visibleMainSlides.length, 
				thumbVisible: visibleThumbSlides.length
			});
			
			// Remover eventos antigos se existirem
			mainSwiper.off('slideChangeTransitionStart');
			mainSwiper.off('slideChange');
			thumbSwiper.off('transitionStart');
			thumbSwiper.off('slideChange');
			
			// Função para atualizar classes CSS de estado ativo
			const updateActiveStates = (activeIndex) => {
				debugLog('🎨 Atualizando estados visuais ativos para índice:', activeIndex);
				
				// Remover todas as classes ativas
				visibleMainSlides.forEach(slide => {
					slide.classList.remove('swiper-slide-active', 'swiper-slide-next', 'swiper-slide-prev');
				});
				visibleThumbSlides.forEach(slide => {
					slide.classList.remove('swiper-slide-active', 'swiper-slide-thumb-active');
				});
				
				// Aplicar classe ativa no slide correto
				if (visibleMainSlides[activeIndex]) {
					visibleMainSlides[activeIndex].classList.add('swiper-slide-active');
					debugLog('✅ Main slide ativo aplicado no índice:', activeIndex);
				}
				
				if (visibleThumbSlides[activeIndex]) {
					visibleThumbSlides[activeIndex].classList.add('swiper-slide-active', 'swiper-slide-thumb-active');
					debugLog('✅ Thumb slide ativo aplicado no índice:', activeIndex);
				}
			};
			
			// Estabelecer sincronização do main para thumb
			mainSwiper.on('slideChangeTransitionStart', function() {
				debugLog('📱 Main swiper mudou para slide:', this.activeIndex);
				if (thumbSwiper && !thumbSwiper.destroyed) {
					thumbSwiper.slideTo(this.activeIndex);
					updateActiveStates(this.activeIndex);
					debugLog('🎯 Sincronizando thumb para índice:', this.activeIndex);
				}
			});
			
			// Estabelecer sincronização do thumb para main  
			thumbSwiper.on('slideChange', function() {
				debugLog('🖼️ Thumb swiper mudou para slide:', this.activeIndex);
				if (mainSwiper && !mainSwiper.destroyed) {
					mainSwiper.slideTo(this.activeIndex);
					updateActiveStates(this.activeIndex);
					debugLog('🎯 Sincronizando main para índice:', this.activeIndex);
				}
			});
			
			// Adicionar evento de clique manual nas miniaturas
			visibleThumbSlides.forEach((slide, visibleIndex) => {
				slide.removeEventListener('click', slide._thumbClickHandler);
				
				slide._thumbClickHandler = function(e) {
					e.preventDefault();
					debugLog(`🖱️ Clique manual na miniatura visível ${visibleIndex}`);
					
					if (mainSwiper && !mainSwiper.destroyed) {
						mainSwiper.slideTo(visibleIndex);
						debugLog(`🎯 Navegando main para índice visível: ${visibleIndex}`);
					}
					if (thumbSwiper && !thumbSwiper.destroyed) {
						thumbSwiper.slideTo(visibleIndex);
						debugLog(`🎯 Navegando thumb para índice visível: ${visibleIndex}`);
					}
					
					// Atualizar estados visuais imediatamente
					updateActiveStates(visibleIndex);
				};
				
				slide.addEventListener('click', slide._thumbClickHandler);
			});
			
			// Aplicar estado ativo inicial
			setTimeout(() => {
				updateActiveStates(mainSwiper.activeIndex || 0);
				debugLog('🎯 Estado ativo inicial aplicado');
			}, 100);
			
			debugLog('✅ Sincronização estabelecida com sucesso com mapeamento correto');
			
		} catch (error) {
			debugLog('❌ Erro ao estabelecer sincronização:', error);
		}
	}
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
	constructor() {
		super();
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
				input.classList.remove("disabled");
			} else {
				input.classList.add("disabled");
			}
		});
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll("fieldset"));
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll("input")).find(
				(radio) => radio.checked
			).value;
		});
	}
}

customElements.define("variant-radios", VariantRadios);

(function () {
	const imageMouseParallax = (options) => {
		options = options || {};
		this.nameSpaces = {
			wrapper: options.wrapper || ".parallax",
			layers: options.layers || ".parallax-layer",
			deep: options.deep || "data-parallax-deep",
		};

		this.init = function () {
			var self = this;
			var parallaxWrappers = document.querySelectorAll(this.nameSpaces.wrapper);

			for (var i = 0; i < parallaxWrappers.length; i++) {
				(function (i) {
					parallaxWrappers[i].addEventListener("mousemove", function (e) {
						var x = e.clientX;
						var y = e.clientY;
						var layers = parallaxWrappers[i].querySelectorAll(
							self.nameSpaces.layers
						);

						for (var j = 0; j < layers.length; j++) {
							(function (j) {
								var deep = layers[j].getAttribute(self.nameSpaces.deep);
								var disallow = layers[j].getAttribute("data-parallax-disallow");
								var itemX = disallow && disallow === "x" ? 0 : x / deep;
								var itemY = disallow && disallow === "y" ? 0 : y / deep;

								if (disallow && disallow === "both") return;
								layers[j].style.transform =
									"translateX(" + itemX + "%) translateY(" + itemY + "%)";
							})(j);
						}
					});
				})(i);
			}
		};
		this.init();
		return this;
	};

	document.addEventListener("shopify:section:load", imageMouseParallax);

	imageMouseParallax();
})();

// Aplicar filtro de cor no carregamento inicial da página
document.addEventListener('DOMContentLoaded', function() {
	// Sistema de filtro de cor inicializado
	
	// Adicionar CSS para elementos filtrados
	if (!document.getElementById('color-filter-styles')) {
		const style = document.createElement('style');
		style.id = 'color-filter-styles';
		style.textContent = `
			.color-filtered-hidden {
				display: none !important;
				visibility: hidden !important;
				opacity: 0 !important;
				position: absolute !important;
				left: -9999px !important;
				top: -9999px !important;
				width: 0 !important;
				height: 0 !important;
				overflow: hidden !important;
				pointer-events: none !important;
			}
		`;
		document.head.appendChild(style);
	}
	
	// Aguardar um pouco para garantir que todos os elementos estão carregados
	setTimeout(() => {
		if (window.location.pathname.includes('/products/')) {
			// Aplicar filtro inicial na página de produto
			const tempInstance = Object.create(VariantSelects.prototype);
			tempInstance.applyColorFilter();
		}
	}, 500);
});

// Também aplicar quando a seção é carregada (Shopify theme editor)
document.addEventListener('shopify:section:load', function() {
	setTimeout(() => {
		if (window.location.pathname.includes('/products/')) {
			const tempInstance = Object.create(VariantSelects.prototype);
			tempInstance.applyColorFilter();
		}
	}, 200);
});

// Debounce para evitar múltiplas execuções
let colorFilterTimeout;

// Listener para mudanças de cor que aplica o filtro imediatamente
document.addEventListener('change', function(e) {
	// Verificar se é uma mudança de cor
	if (e.target.matches('input[type="radio"]') && 
	    (e.target.name.includes('CORES') || e.target.name.includes('COR') || e.target.name.includes('COLOR'))) {
		
		// Limpar timeout anterior se existir
		if (colorFilterTimeout) {
			clearTimeout(colorFilterTimeout);
		}
		
		// Aplicar filtro com debounce
		colorFilterTimeout = setTimeout(() => {
			const tempInstance = Object.create(VariantSelects.prototype);
			tempInstance.applyColorFilter();
		}, 100);
	}
});

// 🚨 MODO DEPURADOR DESATIVADO 🚨
window.DEBUG_COLOR_FILTER = false;
window.RECREATING_SWIPERS = false; // Flag para evitar loop infinito

function debugLog(message, data = null) {
	// Debug desativado em produção
	// if (window.DEBUG_COLOR_FILTER) {
	// 	console.log(`🔍 [COLOR FILTER DEBUG] ${message}`, data || '');
	// }
}

// Interceptar sliderInit para garantir que o filtro seja aplicado
const originalSliderInit = sliderInit;

window.sliderInit = function(isUpdate) {
	// Chamar a função original
	const result = originalSliderInit(isUpdate);
	
	// Só aplicar filtro se NÃO estivermos recriando swipers
	if (!window.RECREATING_SWIPERS) {
		// Aplicar filtro após a inicialização do swiper
		setTimeout(() => {
			if (window.location.pathname.includes('/products/')) {
				const tempInstance = Object.create(VariantSelects.prototype);
				tempInstance.applyColorFilter();
			}
		}, 150);
	}
	
	return result;
};

// Interceptar subSliderInit também
const originalSubSliderInit = subSliderInit;

window.subSliderInit = function(isUpdate) {
	// Chamar a função original
	const result = originalSubSliderInit(isUpdate);
	
	// Só aplicar filtro se NÃO estivermos recriando swipers
	if (!window.RECREATING_SWIPERS) {
		// Aplicar filtro após a inicialização do swiper
		setTimeout(() => {
			if (window.location.pathname.includes('/products/')) {
				const tempInstance = Object.create(VariantSelects.prototype);
				tempInstance.applyColorFilter();
			}
		}, 150);
	}
	
	return result;
};

// Remove border-radius de todos os elementos exceto do carrossel
function removeBorderRadius() {
  const elementsWithBorderRadius = document.querySelectorAll('*:not(.featured-products--carousel):not(.featured-products--carousel *)');
  elementsWithBorderRadius.forEach(element => {
    const computedStyle = window.getComputedStyle(element);
    if (computedStyle.borderRadius !== '0px' && !element.closest('.featured-products--carousel')) {
      element.style.setProperty('border-radius', '0', 'important');
    }
  });
}

// Executar quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', function() {
  removeBorderRadius();
  
  // Observar mudanças no DOM para remover border-radius de elementos dinâmicos
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        removeBorderRadius();
      }
    });
  });
  
  // Configurar o observer para monitorar todo o documento
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
